<div class="container-fluid bg-white h-100">
  @if (loaded) {
    <div class="row h-100">
      <div class="col-md-12 text-center pb-4 h-100 d-flex flex-column flex-nowrap">
        <div class="row">
          <div class="col-sm-12 text-center pb-4">
            <p class="page-header"><span>{{model?.modelName}}</span></p>
            <h2>{{model?.modelNameId}}</h2>
          </div>
        </div>
        <div class="flex-container">
          <div class="col-md-4 flex-container-start">
            <div (click)="catalogList()" class="catalog-list">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                class="bi bi-arrow-left-circle-fill catalog-list-icon" viewBox="0 0 16 16">
                <path
                  d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
              </svg>
              <span class="catalog-list-label ml-2"> {{'TORNA_AL_CATALOGO' | translate | uppercase}}</span>
            </div>
          </div>
          <div class="col-md-4 p-0">
            @if (!isCopyingConfiguration()) {
              <span class="model-choise">{{'SCEGLI_MODELLO' | translate | uppercase}}</span>
            }
            @if (isCopyingConfiguration()) {
              <div>
                <div class="copying-label"> {{ 'SELECT_TO_COPY' | translate }}
                  <span class="copying-label-cancel" (click)="cancelCopyingConfiguration()">{{'ANNULLA' | translate}}</span>
                </div>
              </div>
            }
          </div>
          <div class="col-md-4 flex-container-end">
            <!--<button (click)="customModel()" class="custom-model">
            {{'MODELLO_SU_MISURA' | translate | uppercase}}
          </button>-->
          <button (click)="goToModelDetailGrid()" class="btn pr-0" type="button">
            <span matTooltip="{{'VISUALIZZAZIONE_GRIGLIA' | translate}}" matTooltipPosition="below">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor"
                class="bi bi-grid button-icon"
                viewBox="0 0 16 16">
                <path
                  d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z"/>
              </svg>
            </span>
          </button>
        </div>
      </div>
      <div class="divisor-top models text-left pb-2">
        @if (model?.academyUrl) {
          <h3 class="m-0">
            <a class="red" [href]="model?.academyUrl" target="_blank">
              {{'VISIONNAIRE_ACADEMY_MODEL' | translate}}
              <i class="fa fa-external-link" aria-hidden="true"></i>
            </a>
          </h3>
        }
      </div>
      <div class="models-container">
        <div class="models h-100">
          <app-model-detail [products]="modelElements" [openedViaModelList]="true"></app-model-detail>
          <!--          <div class="row margin-bottom-30 input-container">-->
          <!--            <input #myInput (input)="filterItem(myInput.value)" [(ngModel)]="searchText"-->
          <!--                   aria-describedby="search-text"-->
          <!--                   autofocus class="form-control border-radius-0 input-size" id="search-text"-->
          <!--                   placeholder="{{'CERCA_MODELLO' | translate}}"-->
          <!--                   type="email">-->
        <!--          </div>-->
        <!--          <div class="flex-column text-center">-->
        <!--            <div (click)="configureModelElement(modelElement)" *ngFor="let modelElement of filteredItems"-->
        <!--                 class="flex-row">-->
        <!--              <img [alt]="modelElement?.productName" [src]="convertProductImage(modelElement) | repairImageUrl" class=""/>-->
        <!--              <p class="model-name">{{modelElement?.productName}}</p>-->
      <!--            </div>-->
    <!--          </div>-->
    <!--          <div *ngIf="filteredItems?.length === 0" class="col-sm-10 mt-3 text-left">-->
    <!--            <span>{{"NESSUNA_CORRISPONDENZA" | translate}}</span>-->
  <!--          </div>-->
</div>
@if (!loaded) {
  <app-visionnaire-loader class="ipe:w-full" />
}
</div>
</div>
</div>
}
</div>
@if (!loaded) {
  <app-visionnaire-loader class="ipe:w-full" />
}
